import { createEffect } from 'effector';
import { api } from '../../api/axiosinstance.js';

export const getFeaturesFx = createEffect().use(async () => {
  return (await api(false).get('feature-collection')).data;
});

export const getRegionsFx = createEffect().use(async () => {
  return (await api(false).get('regions')).data;
});

export const getIzParticipantsFx = createEffect().use(async () => {
  return (await api(false).get('iz-participants')).data;
});

export const getSezParticipantsFx = createEffect().use(async () => {
  return (await api(false).get('sez-participants')).data;
});

export const getLaborByActivityFx = createEffect().use(async () => {
  return (await api(false).get('labor-by-activity')).data;
});

export const getRoadsInRegionsFx = createEffect().use(async () => {
  return (await api(false).get('roads-in-regions')).data;
});

export const getVRPYearlyFx = createEffect().use(async () => {
  return (await api(false).get('vrp-yearly')).data;
});

export const getRegionCodesFx = createEffect().use(async () => {
  return (await api(false).get('dict/region-codes')).data;
});

export const getIzParticipantsDictFx = createEffect().use(async () => {
  return (await api(false).get('dict/iz-participants')).data;
});

export const getSezParticipantsDictFx = createEffect().use(async () => {
  return (await api(false).get('dict/sez-participants')).data;
});

export const getHexagonsFx = createEffect().use(async () => {
  return (await api(false).get('h3-data')).data;
});

export const getKazakhstanFx = createEffect().use(async () => {
  return (await api(false).get('kz-geojson')).data;
});

export const getPoiFx = createEffect().use(async () => {
  return (await api(false).get('poi')).data;
});

export const getPopulationByAgeFx = createEffect().use(async () => {
  return (await api(false).get('population-by-age')).data;
});

export const getChartsRawDataFx = createEffect().use(async () => {
  return (await api(false).get('charts')).data;
});
